/**
 * This file contains all the constants used in the application
 */

// Base URL for the API
export const BASE_URL =
  process.env.REACT_APP_BASE_URL || "http://localhost:8080";
